'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class recoveryModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	
	getValue(name){
		switch(name){
			case 'type':
				return this.getClassifValue(name, 'recovery_type');
			case 'linked_to_breach':
				return this.getClassifValue(name, 'yesno');
			case 'irregularities_ids':
				return this.getClassifOtherValue(name, 'irregularities');
			case 'participants_ids':
				return this.getClassifOtherValue(name, 'participants');
			case 'amount':
			case 'paid_amount':
			case 'late_interest_amount':
				return this.s('$filter')('currency')(this[name]);
			case 'status':
				return this.getClassifValue(name, 'project_recovery_status');
			case 'expiry_date':
			case 'created':
			case 'status_time':
			case 'payment_date':
			case 'decision_date':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name]);
			case 'justification':
			case 'comment':
				return this.s('$filter')('nl2br')(this[name]);
			case 'late_payment_interest':
				if(typeof(this[name]) === 'undefined' || this[name] === ''){
					return '';
				}
				return this.setFloatNumber(this[name], 3);
			case 'bank_account_name':
				return this.getBankAccountValue('name');
			case 'bank_account_holder':
				return this.getBankAccountValue('holder');
			case 'bank_account_iban':
				return this.getBankAccountValue('iban');
			case 'bank_account_swift':
				return this.getBankAccountValue('swift');
				
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
	getBankAccountValue(subname){
		if(typeof(this.bank_account) !== 'undefined' && typeof(this.bank_account[subname]) !== 'undefined' && this.bank_account[subname] !== ''){
			return this.bank_account[subname];
		}
		return null;
	}
	
	afterSetup(data){
		if (typeof this.amount !== 'undefined' && !isNaN(this.amount) && this.amount > 0) {
			this.amount = Number(parseFloat(this.amount).toFixed(2));
		} else {
			this.amount = Number(0.00);
		}
		if (typeof this.paid_amount !== 'undefined' && !isNaN(this.paid_amount) && this.paid_amount > 0) {
			this.paid_amount = Number(parseFloat(this.paid_amount).toFixed(2));
		} else {
			this.paid_amount = Number(0.00);
		}
		if (typeof this.late_interest_amount !== 'undefined' && !isNaN(this.late_interest_amount) && this.late_interest_amount > 0) {
			this.late_interest_amount = Number(parseFloat(this.late_interest_amount).toFixed(2));
		} else {
			this.late_interest_amount = Number(0.00);
		}
		if(this.decision_date > 0){
			this.makeCetField('decision_date', true);
			this.decision_date_cet.setHours(12);
		}
		else{
			this.decision_date_cet = null;
		}
		if(this.expiry_date > 0){
			
			this.makeCetField('expiry_date', true);
			this.expiry_date_cet.setHours(12);
			// kadangi laikas buna iki paskutines dienos sekundes cet laike tai pvz LT laiko juostai persivercia diena, bandom atsukti laikrodi i 12 dienos
			this.expiry_date -= (12 * 60 * 60); 
		}
		else{
			this.expiry_date_cet = null;
		}
		if(this.payment_date > 0){
			this.makeCetField('payment_date', true);
			this.payment_date_cet.setHours(12);
		}
		else{
			this.payment_date_cet = null;
		}
	}
	
	setFloatNumber(value){
		let precision = 2;
		if(arguments[1]){
			precision = parseInt(arguments[1]);
		}
		if(!isNaN(value)){
			return Number(parseFloat(value).toFixed(precision));
		}
		else{
			return Number(0.0);
		}
	}
}
